module.exports = __webpack_public_path__ + "static/img/hb_13-min.344cbc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_13-min.png
// module id = aWx7
// module chunks = 1